import  request  from '../../Interceptor/request.js'

//获取缴费单位
export function addPayment(data) {
    return request({
        url: '/paymentInfo',
        method: 'post',
        data
    })
}
